import { render, staticRenderFns } from "./manifestInvitationDialog.vue?vue&type=template&id=1c7a1d6a&"
import script from "./manifestInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./manifestInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7a1d6a')) {
      api.createRecord('1c7a1d6a', component.options)
    } else {
      api.reload('1c7a1d6a', component.options)
    }
    module.hot.accept("./manifestInvitationDialog.vue?vue&type=template&id=1c7a1d6a&", function () {
      api.rerender('1c7a1d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/manifestInvitationDialog.vue"
export default component.exports